import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PlatformSaleService } from 'src/app/services/platform-sale/platform-sale.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
@Injectable({
  providedIn: 'root'
})
export class PlatformSaleResolver implements Resolve<any> {

  constructor(private platformSaleService: PlatformSaleService,private browserServices: BrowserStorageService) { }

    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<Array<any>>|Promise<Array<any>>| Array<any> {
      return this.getPlatformSaleData();
    }

  /**
   * Get PlatformData Data
   * @returns
   */
  getPlatformSaleData(): Observable<Array<any>> { 
    let platFormActiveSaleList: Array<any> = [];
    let currentUser = this.browserServices.getCurrentRoles();
      return this.platformSaleService.getActivePlatFormSale().pipe(
        map((response: any) => {
          platFormActiveSaleList = response?.data?.sales;
          return platFormActiveSaleList;
        }), catchError((error) => {
          return of(platFormActiveSaleList);
    }));
  }
}
